import { render } from "./Profile.vue?vue&type=template&id=252d65d0&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=252d65d0&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252d65d0"]])

export default __exports__